import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import getBanks from '../../services/getBanks';
import { IoMdRefresh } from "react-icons/io";

const BanksSearchBar = (props) => {
  const t = props.t;
  const navigate = useNavigate();
  const [banks, setBanks] = useState([]);
  const [bankToFind, setBankToFind] = useState(null);

  const origins = [
    { value: '', label: 'Origen' },
    { value: '1', label: 'Cajero' },
    { value: '2', label: 'Teleconnect sin IVA' },
    { value: '3', label: 'Teleconnect con IVA' },
    { value: '4', label: 'Recargas' },
    { value: '5', label: 'Teleconnect Prosper' },
    { value: '6', label: 'VoipTel' }
  ];

  const exportExcel = () => {
    let url = "https://api2.coinfru.com/api/bank_entries_react/export/excel?";
    if (props.bankToFind) url += "&bank_id=" + props.bankToFind;
    if (props.startDate) url += "&startDate=" + props.startDate;
    if (props.endDate) url += "&endDate=" + props.endDate;
    if (props.originId) url += "&origin_id=" + props.originId;
    if (props.textToFind) url += "&textToFind=" + props.textToFind;
    url += "&token=" + props.loginParameters.accesToken;
    window.open(url, '_blank');
  };

  const clearPage = () => {
    props.setCurrrentPage(1);
    props.setBankToFind('');
    props.setStartDate(props.getDefaultStartDate());
    props.setEndDate(props.getDefaultEndDate());
    props.setOriginId('');
    props.setTextToFind('');
    setBankToFind(null);
  };

  const handleBankChange = (e) => {
    if (e) {
      setBankToFind({ label: e.label, value: e.value });
      props.setBankToFind(e.value);
    } else {
      setBankToFind(null);
      props.setBankToFind('');
    }
    props.setCurrrentPage(1);
  };

  const handleOriginChange = (e) => {
    props.setOriginId(e ? e.value : '');
    props.setCurrrentPage(1);
  };

  const handleRefresh = () => {
    props.onRefresh();
  };

  useEffect(() => {
    getBanks(props.loginParameters.accesToken).then(banks => setBanks(banks));
  }, [props.loginParameters.accesToken]);

  return (
    <div style={{ padding: "20px" }}>
      <Container>
        <Row className="justify-content-md-center mb-3 align-items-center">
          <Col md="auto">
            <input
              type="date"
              className="form-control"
              value={props.startDate}
              onChange={(e) => { props.setStartDate(e.target.value); props.setCurrrentPage(1); }}
              style={{width: '150px'}}
            />
          </Col>
          <Col md="auto">
            <input
              type="date"
              className="form-control"
              value={props.endDate}
              onChange={(e) => { props.setEndDate(e.target.value); props.setCurrrentPage(1); }}
              style={{width: '150px'}}
            />
          </Col>
          <Col md="auto">
            <Select
              options={origins}
              onChange={handleOriginChange}
              placeholder="Origen"
              isClearable
              styles={{container: (base) => ({...base, width: 150})}}
            />
          </Col>
          <Col md="auto">
            <Select
              options={banks}
              onChange={handleBankChange}
              placeholder={t('banks.bank_to_search')}
              value={bankToFind}
              isClearable
              styles={{container: (base) => ({...base, width: 180})}}
            />
          </Col>
          <Col md="auto">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar en cualquier campo"
              value={props.textToFind}
              onChange={(e) => { props.setTextToFind(e.target.value); props.setCurrrentPage(1); }}
              style={{width: '200px'}}
            />
          </Col>
          <Col md="auto">
            <input
              type="number"
              className="form-control"
              value={props.perPage}
              onChange={(e) => { props.setPerPage(e.target.value); props.setCurrrentPage(1); }}
              style={{width: '60px'}}
              min="5"
              max="100"
            />
          </Col>
          <Col md="auto">
            <Button variant="primary" onClick={clearPage}>
              {t('clean')}
            </Button>
          </Col>
          <Col md="auto">
            <Button variant="success" onClick={() => navigate('/bank_entries/create')}>
              {t('banks.create_bank_entry')}
            </Button>
          </Col>
          <Col md="auto">
            <Button variant="outline-success" onClick={exportExcel} title="Exportar Excel" style={{marginRight:'5px'}}>
              📥 Excel
            </Button>
            <Button variant="outline-primary" onClick={handleRefresh} title="Refrescar">
              <IoMdRefresh size={20} />
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BanksSearchBar;
